import Dexie, { type EntityTable } from 'dexie';

export type QueuedMutation = {
  operationId: string;
  method: 'POST' | 'PATCH' | 'PUT' | 'DELETE';
  url: string;
  body: unknown;
  createdAt: string;
  status: 'pending' | 'syncing' | 'failed';
  lastError?: string;
};

export type ClientMeta = {
  key: string;
  value: unknown;
};

class BinderClientDb extends Dexie {
  mutations!: EntityTable<QueuedMutation, 'operationId'>;
  meta!: EntityTable<ClientMeta, 'key'>;

  constructor() {
    super('artide-production-binder');
    this.version(1).stores({
      mutations: '&operationId, status, createdAt',
      meta: '&key'
    });
  }
}

export const clientDb = new BinderClientDb();

export async function getMeta<T>(key: string): Promise<T | null> {
  const row = await clientDb.meta.get(key);
  return (row?.value as T | undefined) ?? null;
}

export async function setMeta(key: string, value: unknown): Promise<void> {
  await clientDb.meta.put({ key, value });
}

export async function deleteMeta(key: string): Promise<void> {
  await clientDb.meta.delete(key);
}

export async function clearPrivateLocalData(options: { keepPendingLogout?: boolean } = {}) {
  const pendingLogout = options.keepPendingLogout
    ? await getMeta<boolean>('pendingServerLogout')
    : null;

  await clientDb.transaction('rw', clientDb.mutations, clientDb.meta, async () => {
    await clientDb.mutations.clear();
    await clientDb.meta.clear();
    if (options.keepPendingLogout && pendingLogout) {
      await clientDb.meta.put({ key: 'pendingServerLogout', value: true });
      await clientDb.meta.put({ key: 'forcedSignedOut', value: true });
    }
  });
}
